<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-content">
        <!-- Logo -->
        <div class="logo">
          <img :src="logoUrl" alt="Logo" />
        </div>

        <!-- 描述文本 -->
        <p class="description">30秒视频，1分钟轻松复刻专属您的数字人分身</p>

        <!-- 登录表单 -->
        <el-form :model="form" ref="loginForm" class="login-form" @submit.prevent="handleLogin">
          <el-form-item>
            <el-input v-model="form.account" placeholder="请输入账号" prefix-icon="User" size="large" autocomplete="off" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.password" placeholder="请输入密码" prefix-icon="lock" show-password size="large"
              autocomplete="off" />
          </el-form-item>
          <el-button type="primary" block class="login-button" @click="handleLogin" size="large">
            登录
          </el-button>
          <el-form-item class="agreement-checkbox">
            <el-checkbox v-model="form.agree" size="large">
              勾选即代表您同意并接受 《<a href="#" style="color:#ff5c00">服务协议</a>》与 《<a href="#" style="color:#ff5c00">隐私政策</a>》
            </el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { auth } from "@/utils/auth.js"; // 引入封装的 auth.js
import config from '@/config.js'; // 引入配置文件

export default {
  name: "LoginPage",
  data() {
    return {
      form: {
        account: '',
        password: '',
        agree: false,
      },
      logoUrl: '', // 默认 Logo
    };
  },
  methods: {
    async handleLogin() {
      if (!this.form.account || this.form.account.length < 6) {
        this.$message.error("请输入至少6位的账号");
        return;
      }
      if (!this.form.password || this.form.password.length < 6) {
        this.$message.error("请输入至少6位的密码");
        return;
      }
      if (!this.form.agree) {
        this.$message.error("请阅读并同意《服务协议》《隐私政策》");
        return;
      }

      try {
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/login.php`,
          {
            account: this.form.account,
            password: this.form.password,
          }
        );

        if (response.data.success) {
          this.$message.success("登录成功");

          // 保存账号密码到本地存储
          auth.saveUser({
            id: response.data.data.id, // 保存用户 ID
            account: this.form.account,
            password: this.form.password,
          }, true); // 传递 true 以保存到 localStorage

          this.$router.push({ path: "/home/image-cloning" }); // 跳转到默认页面
        } else {
          this.$message.error(response.data.error || "登录失败");
        }
      } catch (error) {
        console.error("登录请求错误:", error);
        this.$message.error("登录失败，请检查网络或稍后重试");
      }
    },

    // 获取当前运行域名
    getCurrentHost() {
      return window.location.origin; // 返回完整域名，例如 "https://example.com"

    },

    // 调用接口获取 Logo
    async fetchLogo() {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/get_agent_info.php`, {
          agent_host: this.getCurrentHost(), // 传递当前域名
        });

        if (response.data.pc_logo) {
          this.logoUrl = response.data.pc_logo; // 更新 Logo
        }
      } catch (error) {
        console.error("获取 Logo 失败:", error);
      }
    },
  },
  mounted() {
    auth.autoRedirect(this.$router); // 自动跳转到主页
    this.fetchLogo(); // 获取 Logo
  },
  created() {
    const savedUser = auth.getStoredUser();
    if (savedUser) {
      this.form.account = savedUser.account;
      this.form.password = savedUser.password; // 恢复密码
      this.form.agree = true; // 自动勾选同意协议
    }
  },
};
</script>

<style scoped>
/* 页面背景 */
.login-page {
  height: 100vh;
  background: url('https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250124/202501240209261a3451799.png') no-repeat center center fixed;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

/* 登录容器 */
.login-container {
  width: 100%;
  max-width: 400px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  padding: 40px 30px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
}

/* 登录内容 */
.login-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Logo */
.logo img {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}

/* 描述文本 */
.description {
  font-size: 14px;
  color: #807d7c;
  font-family: 'PingFang HK', sans-serif;
  text-align: center;
  margin-bottom: 30px;
}

/* 登录表单 */
.login-form .el-input {
  margin-bottom: 20px;
}

/* 登录按钮 */
.login-button {
  border-radius: 8px;
  width: 100%;
  background: #ff5c00;
  color: #fff;
  border: none;
  transition: background-color 0.3s;
}

/* 增加更高特异性的悬停样式，防止被覆盖 */
.login-button:hover {
  background: #e04b00 !important;
  /* 保持按钮在悬停时为深橙色，避免变成蓝色 */
  color: #fff !important;
}

/* 复选框容器 */
.agreement-checkbox {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-container {
    padding: 30px 20px;
  }

  .logo img {
    width: 100px;
    margin-bottom: 15px;
  }

  .description {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>